import { ChevronsUpDownIcon } from '../../Icons';
import { headCellVariants } from './logic';
import styles from './styles.module.scss';

type HeadType = 'text' | 'none';

type BaseProps = {
  /** ヘッダーの表示タイプ。デフォルト: 'text' */
  type?: HeadType;
  /** テキスト（type='text' の場合に表示） */
  label?: string;
  /** テキストを右寄せにする。デフォルト: false */
  rightTextAlign?: boolean;
  /** 追加のクラス名 */
  className?: string;
};

type SortableProps = { sortable: true; onSort: () => void } | { sortable?: false; onSort?: never };

type Props = BaseProps & SortableProps;

export const TableHeadCell: React.FC<Props> = ({
  type = 'text',
  label,
  rightTextAlign = false,
  sortable = false,
  onSort,
  className,
}) => {
  const align = rightTextAlign ? 'right' : 'left';

  if (type === 'none') {
    return <th className={[headCellVariants({ align }), className].filter(Boolean).join(' ')} />;
  }

  return (
    <th className={[headCellVariants({ align }), className].filter(Boolean).join(' ')}>
      {sortable ? (
        <button type='button' className={styles.sortableButton} onClick={onSort}>
          {label}
          <ChevronsUpDownIcon size='xs' className={styles.sortIcon} />
        </button>
      ) : (
        label
      )}
    </th>
  );
};
